import {Component, OnInit}        from '@angular/core';
import {FaqCategory}              from '../enums/enums';
import {NavController}            from '@ionic/angular';
import {NavigationExtras}         from '@angular/router';
import {DataStore, SortDirection} from '@aws-amplify/datastore';
import {Faq}                      from '../../models';
import {PredicateAll}             from '@aws-amplify/datastore/lib-esm/predicates';
import {Predicates}               from 'aws-amplify';
import {SessionService}           from "../services/session.service";

@Component({
    selector: 'app-faq-category',
    templateUrl: './faq-category.page.html',
    styleUrls: ['./faq-category.page.scss'],
})
export class FaqCategoryPage implements OnInit {

    constructor(private router: NavController,
                public sessionService: SessionService
    ) {
    }

    colors = [
        '.red',
        '.green',
        '.blue',
        '.purple',
        '.yellow',
        '.violet',
        '.orange',
        '.turquoise',
    ];
    categories = FaqCategory;
    searchWord = '';
    faqs = [];

    ngOnInit() {

    }

    routeTo(category) {
        let navigationExtras: NavigationExtras = {
            state: {
                user: category,
            },
        };
        this.router.navigateForward('/faq', navigationExtras);

    }

    back() {
        this.router.back();

    }

    async searchCat() {
        
        if (this.searchWord != '') {
            let f = [];
            f = await DataStore.query(Faq, Predicates.ALL,
                    {
                        sort: l => l.order(SortDirection.ASCENDING),
                    });
            f = f.filter(x => x.answer?.toLocaleLowerCase().includes(this.searchWord.toLocaleLowerCase())
                    || x.question?.toLocaleLowerCase().includes(this.searchWord.toLocaleLowerCase()));
            
            this.faqs = f;
        } else {
            this.faqs = [];
        }
    }

    async change($event: any) {
        this.searchWord = $event.detail.value;
        await this.searchCat();
    }
}
